<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-10-25 16:36:57
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-15 14:14:00
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/views/webToMini/commonMiniSchemeByMessage.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template></template>
<script>
import { GetQueryString } from '@/utils/utils'

var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
export default {
  data() {
    return {}
  },
  methods: {
    initParams(code) {
      return new Promise((resolve, reject) => {
        const config = {
          method: 'get',
          url: `${process.env.VUE_APP_BASE_API}/user/scheme/getSchemeInfo/${code}`,
          headers: {
            'x-call-client-info': JSON.stringify(headerClientInfo),
          },
        }

        this.$http(config).then((res) => {
          resolve(res)
        })
      })
    },
    getParams(params) {
      let paramStr = ''
      Object.keys(params).forEach((item) => {
        if (paramStr === '') {
          paramStr = `${item}=${params[item]}`
        } else {
          paramStr = `${paramStr}&${item}=${params[item]}`
        }
      })
      console.log(paramStr)
      return paramStr
    },
  },
  async created() {
    /**
     * 当前所需参数
     * @param code
     * */
    let code = this.$route.params.code
    document.title = 'WeMeet'
    const { data } = await this.initParams(code)
    console.log(data)

    if (data.type == 'H5_MEETING_REGISTER_PAGE' || data.type == 'H5_MEETING_REGISTER_PAGE2') {
      let params = JSON.parse(data.params)
      let appKey = data.appKey || 'WX_MINI_WEMEET'
      let url = `${process.env.VUE_APP_H5_BASE_URL}${data.path}?identity=${params.identity}&language=EN&meetingType=${params.meetingType}&meetingCode=${params.meetingCode}&appKey=${appKey}`
      window.location.href = url
      return false 
    }
    const configParams = {
      appKey: data.appKey ? data.appKey : 'WX_MINI_MEHZ',
      expireInterval: 0,
      expireTime: 0,
      expireType: 0,
      isExpire: true,
      code: data.code,
      jumpWxa: {
        envVersion: data.env ? data.env : 'release',
        path: data.path ? data.path : '/pages/index/index',
        query: this.getParams(JSON.parse(data.params)),
      },
    }

    const config = {
      method: 'post',
      url: `${process.env.VUE_APP_BASE_API}/user/wx/generateScheme`,
      data: configParams,
      headers: {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      },
    }

    this.$http(config).then((res) => {
      window.location.href = res.data.value
    })
  },
}
</script>

<style>
</style>